import React from 'react';
import { FlexRow } from 'components/styled-components';
import styled from 'styled-components';
import colors from 'utils/colors';
import { NonIdealState } from '@blueprintjs/core';

const SponsorInfo = ({ request, loaded }) => {
  if (loaded) {
    return (
      <FlexRow>
        <Wrapper>
          <SingleRowTable>
            <tbody>
              <tr>
                <th>Sponsor Name</th>
                <th>Email</th>
                <th>Department</th>
              </tr>
              <tr>
                <td>{`${request.sponsorInformation.firstName} ${
                  request.sponsorInformation.lastName
                }`}</td>
                <td>{request.sponsorInformation.email}</td>
                <td>{request.sponsorInformation.department}</td>
              </tr>
            </tbody>
          </SingleRowTable>
        </Wrapper>
      </FlexRow>
    );
  } else {
    return (
      <NonIdealState
        icon="error"
        title="Sponsor Information Not Found"
        description={'The system could not retrieve valid Sponsor information.'}
      />
    );
  }
};

const Wrapper = styled.div`
  width: 100%;
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SingleRowTable = styled.table`
  width: 100%;
  text-align: left;

  th {
    font-size: 0.75rem;
    color: ${colors.gray};
  }
`;

export default SponsorInfo;
